import React, { useEffect, useState } from "react";
import { Box, TextField } from "@mui/material";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const UrlField = ({
  submittedAnswer,
  responseAnswer,
  isFrom,
  handleQuesAnswer,
  event,
  comment,
  linkageAnswer,
  question,
  hasAttachedDocument,
}) => {
  const [url, setUrl] = useState("");
  const [commentBox, setCommentBox] = useState("");
  const [attachDocument, setAttachDocument] = useState(null);

  useEffect(() => {
    if (submittedAnswer?.length > 0) {
      setUrl(submittedAnswer?.[0]?.value || "");
      setCommentBox(submittedAnswer?.[0]?.comment || "");
      setAttachDocument(submittedAnswer[0]?.supporting_document || null);
    }
  }, []);

  const handleUpdate = (type, data) => {
    let newUrl = url;
    let newComment = commentBox;

    if (type === "url") newUrl = setUrl(data) || data;
    else if (type === "comment") newComment = setCommentBox(data) || data;
    else if (type === "document") setAttachDocument(data);

    if (isFrom === "taskSection") {
      handleQuesAnswer({
        obj: {
          value: type === "url" ? data : url,
          weightage: 1,
          comment: type === "comment" ? data : commentBox,
          supporting_document:
            type === "document" && data === null ? data : attachDocument,
          document: type === "document" ? data : attachDocument,
          documentMetaData:
            type === "document"
              ? {
                  ques_id: question?._id,
                  name: data?.name,
                  is_supporting_document: true,
                  type: data?.type,
                }
              : null,
        },
        realQuestion: question,
      });
    }
  };

  const placeholderSize = {
    inputProps: { sx: { fontSize: "14px" } },
  };
  const labelSize = { style: { fontSize: "14px" } };

  return (
    <Box
      mt={2}
      style={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : event || "auto",
      }}
    >
      <TextField
        label="Url"
        variant="outlined"
        fullWidth
        value={url}
        onChange={(e) => handleUpdate("url", e.target.value)}
        size="small"
        InputLabelProps={labelSize}
        InputProps={placeholderSize}
      />

      {comment && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <AdvancedInputField
            name="comment"
            data={commentBox}
            placeholder="Contributor's comment"
            handleChange={({ name, value }) => handleUpdate(name, value)}
          />
        </Box>
      )}
      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleUpdate}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default UrlField;
